import React from "react";

/**
 * ZildLogo — uses the official Zild brand mark (SVG with stylised coffee-trace
 * decorations around the wordmark) in the official petroleum-blue palette.
 *
 * variant: "ink" (dark on paper) | "inverse" (white on dark blue)
 */
const ZildLogo = ({ variant = "ink", size = 26, dataTestId = "zild-logo" }) => {
    const src =
        variant === "inverse"
            ? "/assets/brand/zild-logo-light.svg"
            : "/assets/brand/zild-logo.svg";

    return (
        <img
            src={src}
            alt="Zild"
            data-testid={dataTestId}
            width={Math.round(size * 2.5)}
            height={size}
            style={{
                height: size,
                width: "auto",
                display: "block",
                userSelect: "none",
            }}
            draggable={false}
        />
    );
};

export default ZildLogo;
